"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOwnClient = createOwnClient;
var _graphqlRequest = require("graphql-request");
var _ScriptLoader = require("../../packages/ScriptLoader");
const withWafTokenMiddleware = async function (request) {
  const AwsWafIntegration = (0, _ScriptLoader.waitForGlobal)("AwsWafIntegration");
  const token = await AwsWafIntegration.getToken().then(function (data) {
    return data;
  });
  return {
    ...request,
    headers: {
      ...request.headers,
      "X-Aws-Waf-Token": token
    }
  };
};
function createOwnClient(generalClient) {
  if (generalClient) {
    return new _graphqlRequest.GraphQLClient(generalClient.url, {
      headers: generalClient.requestConfig.headers,
      requestMiddleware: withWafTokenMiddleware
    });
  }
  return generalClient;
}